import { useTranslation } from "react-i18next";

/**
 * @param {object} item - device from Securonix threats
 */
export default function RowThreats({ item }) {
    const { t } = useTranslation();
    const policies = Array.isArray(item?.policies) ? item.policies : [];

    return (
        <>
            <h3 className="table-accordion_title">{t("Informations detaillees des menaces")}</h3>
            <div className="webex-resume">
                {policies.map((threat, index) => (
                    <div key={index} className="webex-resume-item">
                        <p className="webex-resume-text">{index + 1} : {threat}</p>
                    </div>
                ))}
            </div>
        </>
    );
}
